import creditEngineRepository, { CreditEngineRepository } from './CreditEngineRepository'

const resource = '/esign';
export default {
  getEsignConfiguration(esignConfigurationRequest) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/configuration`, esignConfigurationRequest);
  },

  triggerDocument(loanId, clientId, documentName) {
    const query = "?loanId=" + loanId + "&clientId=" + clientId + "&documentName=" + documentName;
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`creditAssessment/signeddocument${query}`);
  },

  saveSignMode(signModeRequest) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/saveSignMode`, signModeRequest);
  },

  getEsignSuccessView(loanId) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/callback/${loanId}/success`);
  }
}
